<header>
    <!-- <img src="./assets/login-header.jpg" style="width: 100%;"> -->
    <div class="row">
        <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
            <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
            <!-- <a href="https://rashtragaan.in/">         
                <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
            </a>
            <img src="./../../../assets/logoembdig.png" alt="Dental Council of India" title="Dental Council of India"> -->
       <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
        </div>
    </div>
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-md-6">
                <h5 class="headingValue">Accept Inspection Schedule</h5>
            </div>
            <!-- <div class="col-md-6 text-right">
                <button class="globalBtn clearBtn" routerLink="../login">Back</button>
            </div> -->
        </div>
        <hr>
    </div>
</header>
<div *ngIf='inspectorStatus == "Pending"' class="container h-100" style="background: #eee;padding: 15px;">
    <div class="row">
        <div class="col-md-12 p-0">
            <div class="card">
                <form id="guruId" [formGroup]="formGroupId" role="form" autocomplete="off"
                    class="has-validation-callback">

                    <div class="bt-tab-content-main">

                        <div class="tab-content" style="margin-top: 15px">
                            <div id="signin">

                              <!--  <div class="row" style="color:red">
                                    Note: Please do not accept if you have retired or are no longer working in a
                                    Government Dental College
                                </div>
                                <br>
                                 <div class="row" style="color:blue">
                                    <p>Dear {{InspectorDetails?.name}},</p><br>
                                    <p> You are requested to conduct an inspection
                                    for {{sheduleDetails?.inspectionType}}/ {{sheduleDetails?.subType}}/
                                     {{sheduleDetails?.purpose}}/
                                    {{sheduleDetails?.courseName}} and on
                                    {{sheduleDetails?.inspectionDate}} & {{inspectionDate2}}.
                                    please confirm your participation by clicking on accepting. Your unique
                                    reference number is {{InspectorDetails?.inspectionRefId}}. You will receive a
                                    confimation email shortly after your acceptance and the travel desk will
                                    contact you prior to your day of assessment. For any queries, please call
                                    +91-9818189120 and quote only your reference number.</p>
                                </div> -->
                                <div class="row" style="color:blue">
                                    <p>Dear {{InspectorDetails?.name}},</p><br>
                                    <p style="text-align: justify;"> 
                                      
                                    You are assigned to conduct an inspection on {{inspectionDate}}. 
                                    Kindly confirm by clicking on "Accept" or "Reject". You will receive a confirmation email shortly after your acceptance.</p>
                                     <!-- You are requested to conduct an inspection
                                    for {{sheduleDetails?.subType}} of {{sheduleDetails?.courseName}}  
                                     Please confirm your participation 
                                    by clicking on “Accept”. You will receive a confirmation email shortly after your 
                                    acceptance and our travel partner will contact you prior to your day of assessment.
                                    For any queries, please call +91-9818189120.</p> -->
                                </div>
                                <br>
                                
                          <div style="color:blue; font-weight:bold; display:flex; align-items:flex-start; gap:10px;">

                            <input type="checkbox" formControlName="agreeCheck" style="width:18px; height:18px; accent-color:#000000;
                             border:2px solid #000;   border-radius:3px;" />

                            <label style="margin:0; cursor:pointer;">
                                YOU ARE INFORMED THAT INSPECTORS ARE REGARDED AS PUBLIC SERVANTS WHILE ON INSPECTION 
                                AND THEREFORE MUST DISCHARGE THEIR DUTIES WITH UTMOST SINCERITY, HONESTY AND INTEGRITY.<br>
                                <span style="text-decoration: underline;">
                                    ANY DISCLOSURE OF CONFIDENTIAL INFORMATION RELATING TO INSPECTION SHALL ATTRACT 
                                    PROSECUTION UNDER THE PREVENTION OF CORRUPTION ACT AND OTHER PROVISIONS OF LAW.
                                </span>
                            </label>

                            </div> <br>
                                    <div class="row">
                                    Please click on 'Reject' if you are
                                </div>

                                <div class="row" style="margin-left: 15px;">
                                    *Not available for inspection on assigned dates
                                </div>
                                <div class="row" style="margin-left: 15px;">
                                    *Retired / Not working in a dental college  
                                </div>
                                <div class="row" style="margin-left: 15px;">
                                    *Not willing to conduct assessments
                                </div>                            
                                <div class="row" style="margin-left: 15px;">
                                    *Any other reason
                                </div>

                                <br>

                                <!-- <div class="col-lg-3" >   
    <label class="pt-5" style="white-space: nowrap;">Please provide the valid reason for not accepting this inspection.<br>Reason<span class="requiredClass"> *</span></label>
      <select (change)="acceptenceTypes($event.target.value)" placeholder="Select">
        <option value="" disabled selected style="color:orange">Select</option>
        <option *ngFor="let acceptence of acceptenceType" [value]="acceptence">
            {{ acceptence }} 
        </option>
    </select>  
    
</div> -->
                                <!-- <div *ngIf="remarksshowhide==true" style="margin-top: 6px;" class="col-lg-6">
                                    <input style="width: 110%;" type="text"
                                        (change)="acceptenceTypesothers($event.target.value)" />
                                </div> -->

                                <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="grivFirstName" class="required">Institution Category <span
                                                    class="text-danger">*</span></label>

                                                    <select class="form-control" tabindex="10" formControlName="institutionTypeId"  [ngClass]="{ 'is-invalid': f.institutionTypeId.invalid && (f.institutionTypeId.dirty || f.institutionTypeId.touched) }">
                                                        <option value="" disabled selected style="color:orange">Select Institution</option>
                                                        <option *ngFor="let sec of institutionTypeList" [value]="sec.institutionTypeId">
                                                            {{sec.institutionTypeName}}
                                                        </option>
                                                    </select>
                                                <div *ngIf="submitted && formGroupId.controls['institutionTypeId'].hasError('required')"
                            class="failed-validation" class="errorColor">
                         Institution Type Required
                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                           
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="grivFirstName" class="required">
                                                Association/Hospital/Organization/Others/Trust/University <span
                                                    class="text-danger">*</span></label>

                                            <input id="name" name="name" tabindex="1" formControlName="name"
                                                placeholder="Association/ Hospital/Organization/Others/Trust/University"
                                                type="text" class="form-control"
                                                maxlength="70" (keypress)="keyPressAlphaNumericWithCharacters($event)" >
                                                <div *ngIf="submitted && formGroupId.controls['name'].hasError('required') "
                            class="failed-validation" class="errorColor">
                         Institution Name Required
                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="grivFirstName" class="required">Email Address <span
                                                    class="text-danger">*</span></label>
                                            <input id="userEmail" name="userEmail" tabindex="2" formControlName="userEmail"
                                                placeholder="Email Address" type="text" class="form-control" value=""
                                                maxlength="255"
                            [ngClass]="{ 'is-invalid': f.userEmail.invalid && (f.userEmail.dirty || f.userEmail.touched) }"
                                                >
                                                <div *ngIf="submitted && formGroupId.controls['userEmail'].hasError('required') "
                                                class="failed-validation" class="errorColor">
                                                Email Address Required
                                            </div>
                                            <div *ngIf="submitted && formGroupId.controls['userEmail'].hasError('pattern')" class="failed-validation"
                                                class="errorColor">
                                                Invalid Email Address  
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- <div class="row">
                                    <div class="col-md-6">

                                        
                                    </div>
                                    
                                </div> -->

                                <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="required">Address Line 1 <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" placeholder="Address Line 1"
                                                formControlName="addressLine1"
                                                [ngClass]="{ 'is-invalid': f.addressLine1.invalid && (f.addressLine1.dirty || f.addressLine1.touched) }"
                                                >
                                                <div *ngIf="submitted && formGroupId.controls['addressLine1'].hasError('required') "
                                                class="failed-validation" class="errorColor">
                                                Address Line 1 Required
                                            </div>
                                            <div *ngIf="submitted && formGroupId.controls['addressLine1'].hasError('pattern')" class="failed-validation"
                                                class="errorColor">
                                                Invalid Address Line 1
                                            </div> 
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="required">Address Line 2 <span
                                                    class="text-danger"></span></label>
                                            <input type="text" class="form-control" placeholder="Address Line 2"
                                                formControlName="addressLine2" [ngClass]="{ 'is-invalid': f.addressLine2.invalid && (f.addressLine2.dirty || f.addressLine2.touched) }">
                                                <div *ngIf="submitted && formGroupId.controls['addressLine2'].hasError('required') "
                                                class="failed-validation" class="errorColor">
                                                Address Line 2 Required
                                            </div>
                                            <div *ngIf="submitted && formGroupId.controls['addressLine2'].hasError('pattern')" class="failed-validation"
                                                class="errorColor">
                                                Invalid Address Line 2
                                            </div> 
                                            </div>
                                    </div>
                                </div> -->
                                <!-- <div class="row">
                                    <div class="col-md-6">
                                      
                                    </div>
                                    <div class="col-md-6">
                                       
                                    </div>
                                </div> -->
                                <!-- <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group" tabindex="1">
                                            <label for="ethicCountry" class="required">Country <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="countryId" (change)="findState()" disabled
                                            [ngClass]="{ 'is-invalid': f.countryId.invalid && (f.countryId.dirty || f.countryId.touched) }">
                                                <option value="" disabled selected>Select Country</option>
                                                <option  *ngFor=" let  details of countryList" [value]="details.countryId">
                                                    {{details.countryName}}</option>
                                            </select>
                                            <div *ngIf="submitted && formGroupId.controls['countryId'].hasError('required') "
                            class="failed-validation" class="errorColor">
                            Country Required
                        </div>
                        <div *ngIf="submitted &&  formGroupId.controls['countryId'].invalid 
                                        && (formGroupId.controls['countryId'].dirty )"
                                        class="invalid-feedback">
                                        <div *ngIf="submitted && formGroupId.controls['countryId'].errors.required">
                                            <b> Country is required.</b>
                                        </div>  
                                    </div> 
                                        </div>
                                    </div>
                                    <div class="col-md-6" *ngIf="!stateName">
                                        <div class="form-group" tabindex="1">
                                            <label for="state" class="required">State/UT <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="stateId" (change)="findCity()"
                                            [ngClass]="{ 'is-invalid': f.stateId.invalid && (f.stateId.dirty || f.stateId.touched) }">
                                                <option value="" disabled selected>Select State</option>
                                                <option  *ngFor="let details of stateList" [value]="details.stateId">
                                                    {{details.stateName}}</option>
                                               
                                            </select>
                                            <div *ngIf="submitted && formGroupId.controls['stateId'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            State/UT is Required
                        </div>
                        <div *ngIf="submitted &&  formGroupId.controls['stateId'].invalid 
                        && (formGroupId.controls['stateId'].dirty )"
                        class="invalid-feedback">
                        <div *ngIf="submitted && formGroupId.controls['stateId'].errors.required">
                            <b> State/UT is required.</b>
                        </div>  
                    </div> 
                                        </div>
                                    </div>

                                    <div class="col-md-6" *ngIf="stateName">
                                        <div class="form-group" tabindex="1">
                                            <label for="state" class="required">State/UT <span
                                                    class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" placeholder="State Name"
                                                    formControlName="stateName" maxlength="70"
                                                    [ngClass]="{ 'is-invalid': f.stateName.invalid && (f.stateName.dirty || f.stateName.touched) }">
                                                    <div *ngIf="formGroupId.controls['stateName'].hasError('required') "
                            class="failed-validation" class="errorColor">
                            State/UT is Required
                        </div>
                        <div *ngIf="submitted &&  formGroupId.controls['stateName'].invalid 
                        && (formGroupId.controls['stateName'].dirty)"
                        class="invalid-feedback">
                        <div *ngIf="submitted && formGroupId.controls['stateName'].errors.required">
                            <b> State/UT is required.</b>
                        </div>  
                    </div> 
                                        </div>
                                    </div>

                                </div> -->

                                <!-- <div class="row">
                                    <div class="col-md-6" *ngIf="!cityName">
                                        <div class="form-group" tabindex="1">
                                            <label for="state" class="required">City <span
                                                    class="text-danger">*</span></label>
                                            <select class="form-control" formControlName="cityId" [ngClass]="{ 'is-invalid': f.cityId.invalid && (f.cityId.dirty || f.cityId.touched) }">
                                                <option value="" disabled selected>Select City</option>
                                                <option  *ngFor="let details of cityList" [value]="details.cityId">
                                                    {{details.name}}</option>
                                            </select>
                                            <div *ngIf="submitted && formGroupId.controls['cityId'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            City is Required
                        </div>
                        <div *ngIf="submitted &&  formGroupId.controls['cityId'].invalid 
                                        && (formGroupId.controls['cityId'].dirty )"
                                        class="invalid-feedback">
                                        <div *ngIf="submitted && formGroupId.controls['cityId'].errors.required">
                                            <b> City is required.</b>
                                        </div>  
                                    </div> 
                                        </div>
                                    </div>
                                    <div class="col-md-6" *ngIf="cityName">
                                        <div class="form-group" tabindex="1">
                                            <label for="state" class="required">City <span
                                                    class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" placeholder="City Name"
                                                    formControlName="cityName" maxlength="70"
                                                    [ngClass]="{ 'is-invalid': f.cityName.invalid && (f.cityName.dirty || f.cityName.touched) }">
                                                    <div *ngIf="submitted && formGroupId.controls['cityName'].hasError('required') "
                                                    class="failed-validation" class="errorColor">
                                                 City is Required
                                                </div>
                                                <div *ngIf="submitted &&  formGroupId.controls['cityName'].invalid 
                                        && (formGroupId.controls['cityName'].dirty )"
                                        class="invalid-feedback">
                                        <div *ngIf="formGroupId.controls['cityName'].errors.required">
                                            <b> City is required.</b>
                                        </div>  
                                    </div> 
                                                </div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="grivZipCode" class="required">PIN Code <span
                                                class="text-danger">*</span></label>
                                        <input id="pinCode" name="pinCode" placeholder="PIN Code"
                                            formControlName="pinCode" class="form-control" type="text" value=""
                                            maxlength="6" (keypress)="keyPresspincode($event)">
                                            <div *ngIf="submitted &&  formGroupId.controls['pinCode'].invalid "
                                        class="invalid-feedback">
                                        <div *ngIf="submitted && formGroupId.controls['pinCode'].hasError('required')"
                                        class="failed-validation" class="errorColor">
                                        PIN Code is Required
                                    </div>
                                        <div *ngIf="submitted && formGroupId.controls['pinCode'].hasError('maxlength')" class="failed-validation" class="errorColor">
                                            <b> PIN Code cannot be more than 10 characters long. </b>
                                        </div> 
                                        <div *ngIf="submitted && formGroupId.controls['pinCode'].hasError('minlength')" class="failed-validation" class="errorColor">
                                            <b> PIN Code cannot be less than 6 characters long. </b>
                                        </div>
                                        <div *ngIf="submitted && formGroupId.controls['pinCode'].errors.pattern">
                                            <b>PIN Code should be a number  </b>
                                        </div> 
                                    </div>

                                    </div>
                                </div>
                                 -->
                                <!-- <div class="row">

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="phoneNo" class="required">Mobile Number <span
                                                    class="text-danger">*</span></label>
                                            <input type="text" class="form-control" id="mobileNo"
                                                formControlName="mobileNumber" placeholder="Mobile Number"
                                                (keypress)="keyPresspincode($event)" maxlength="10"
                            [ngClass]="{ 'is-invalid': f.mobileNumber.invalid && (f.mobileNumber.dirty || f.mobileNumber.touched) }"
                            (keypress)="keyPress($event)"
                            data-validation-error-msg='Mobile Number is required'  data-validation-regexp="^[2-9][0-9]*$" data-validation="required length number custom" data-validation-length="10-10"
                                                >
                                                <div *ngIf="submitted && formGroupId.controls['mobileNumber'].hasError('required')"
                            class="failed-validation" class="errorColor">
                            Mobile Number Required
                        </div>
                        <div *ngIf="formGroupId.controls['mobileNumber'].hasError('pattern')"
                            class="failed-validation" class="errorColor">
                            Mobile Number should have starts with 9,8,7,6 and length 10 digits
                        </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="phoneNo" class="required">Landline Number <span
                                                    class="text-danger"></span></label>
                                            <input type="text" class="form-control" id="landlineNo"
                                                formControlName="landlineNumber" placeholder="Landline Number "
                                                (keypress)="keyPresspincode($event)"
                            [ngClass]="{ 'is-invalid': f.landlineNumber.invalid && (f.landlineNumber.dirty || f.landlineNumber.touched) }"
                            (keypress)="keyPress($event)"
                                                >
                                                <div *ngIf="submitted && formGroupId.controls['landlineNumber'].hasError('required') "
                            class="failed-validation" class="errorColor">
                            Landline Number Required
                        </div>
                        
                        <div *ngIf="formGroupId.controls['landlineNumber'].hasError('pattern')"
                            class="failed-validation" class="errorColor">
                            Landline number should have atleast length 10 digits
                        </div>
                                        </div>
                                    </div>

                                </div> -->
                                <div class="row">
                                    <div class="col-md-6">



                                    </div>
                                    <div class="col-md-6">



                                    </div>
                                </div>
                                <div class="row" *ngIf=accdenbuttonhide>
                                    <div class="col-md-12">

                                        <button type="submit" id="grSubmit" data-toggle="modal" data-target="#myModal"
                                            class="btn btn-danger" style="float: right; margin-right: 5px">
                                            Reject
                                        </button>&nbsp;&nbsp;&nbsp;

                                        <button type="submit" id="grSubmit" class="btn btn-success"
                                            (click)="onSubmit('Accept')" style="float: right; margin-right: 5px">
                                            Accept
                                        </button>&nbsp;&nbsp;&nbsp;

                                    </div>
                                </div>
                                <div class="modal" id="myModal">
                                    <div class="modal-dialog modal-md">
                                        <div class="modal-content">

                                            <!-- Modal Header -->
                                            <div class="modal-header">
                                                <h5 class="modal-title headingValue">Please provide the
                                                    valid reason for not accepting this inspection<span class="requiredClass">
                                                        </span></h5>
                                                <!-- <button type="button" class="close" data-dismiss="modal" #dismissModal (click)="onSubmit('Denied')">&times;</button> -->


                                            </div>
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <label class="pt-2" style="white-space: nowrap;">Reason<span class="requiredClass">
                                                        *</span></label>
                                                    <select (change)="acceptenceTypes($event.target.value)"
                                                        placeholder="Select" class="form-control">
                                                        <option value="" disabled selected style="color:orange">Select
                                                        </option>
                                                        <option *ngFor="let acceptence of acceptenceType"
                                                            [value]="acceptence">
                                                            {{ acceptence }}
                                                        </option>
                                                    </select>
                                                    <div style="margin-top: 6px;" *ngIf="remarksshowhide==true">
                                                        <input type="text" class="form-control"
                                                            (change)="acceptenceTypesothers($event.target.value)" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12" style="margin-top: 10px;" align="right"> <button type="button" class="btn btn-danger"
                                                         data-dismiss="modal" #dismissModal
                                                        (click)="onSubmit('Denied')">No ! i'm not Interested </button>&nbsp;&nbsp; <button
                                                        type="button" class="btn btn-primary" data-dismiss="modal"
                                                        #dismissModal>Cancel</button></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div style="text-align: right;" class="col-12 form-group mg-t-8">
                                    <p style="float: left;"> If already registered, click here to </p>
                                    <button style="float: left;" type="button" class="btn btn-primary mx-2" (click)="redirectTo()">Login</button>
                                </div> -->

                            </div>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div *ngIf='inspectorStatus == "Accepted" || inspectorStatus == "Denied"' class="container h-100"
    style="background: green;padding: 15px;margin-top: 54px;text-align: center;font-size: 35px;font-weight: 560;width: 82%;">
    Your response has been recorded.
</div>

<div *ngIf='inspectorStatus == "Not Responded"' class="container h-100"
    style="background: #eee;padding: 15px;margin-top: 54px;text-align: center;font-size: 35px;font-weight: 560;width: 82%;">
    This link is expired due to Inspector Not Responded!!!
</div>

<div *ngIf='inspectorStatus == "Cancelled"' class="container h-100"
    style="background: #eee;padding: 15px;margin-top: 54px;text-align: center;font-size: 35px;font-weight: 560;width: 82%;">
    The inspection is cancelled...
</div>

<div *ngIf='inspectorStatus == "Manual Cancelled"' class="container h-100"
    style="background: #eee;padding: 15px;margin-top: 54px;text-align: center;font-size: 35px;font-weight: 560;width: 82%;">
    Inspector cancelled by Inspection Section...
</div>

<div *ngIf='inspectorStatus == "Manual Confirmation"' class="container h-100"
    style="background: #eee;padding: 15px;margin-top: 54px;text-align: center;font-size: 35px;font-weight: 560;width: 82%;">
    Inspector Manualy Assisged by Inspection Section...
</div>